export interface IAuthConfig {
  httpInterceptor?: boolean;
  loginOnSignup?: boolean;
  baseUrl?: string;
  loginRedirect?: string;
  logoutRedirect?: string;
  signupRedirect?: string;
  loginUrl?: string;
  signupUrl?: string;
  changePasswordUrl?: string;
  loginRoute?: string;
  noAccessRoute?: string;
  tokenRoot?: string;
  tokenName?: string;
  tokenPrefix?: string;
  responseTokenProp?: string;
  authHeader?: string;
  authToken?: string;
  authResponseHeaderForToken?: string;
  storage?: "localStorage" | "sessionStorage";
}

export class AuthConfig implements IAuthConfig {
  httpInterceptor: boolean = true;
  loginOnSignup: boolean = true;
  baseUrl: string = "/";
  loginRedirect: string = "/";
  logoutRedirect: string = "/";
  signupRedirect: string = "/login";
  loginUrl: string = "/auth/login";
  signupUrl: string = "/auth/signup";
  changePasswordUrl: string = "/auth/changepassword";
  loginRoute: string = "/login";
  noAccessRoute: string = "/noaccess";
  tokenRoot?: string = undefined;
  tokenName: string = "token";
  tokenPrefix: string = "aurelia";
  responseTokenProp: string = "access_token";
  authHeader?: string = "Authorization";
  authToken?: string = "Bearer";
  authResponseHeaderForToken: string = "Token";
  storage: "localStorage" | "sessionStorage" = "localStorage";

  configure(config: IAuthConfig) {
    (<any>Object).assign(this, config);
  }
}
